import { subscribe } from '@nextcloud/event-bus';

let token = undefined;
const observers = [];
/**
 * Get current request token
 *
 * @return {string|null} Current request token or null if not set
 */
function getRequestToken() {
    if (token === undefined) {
        // Only on first load, try to get token from document
        const tokenElement = document?.getElementsByTagName('head')[0];
        token = tokenElement ? tokenElement.getAttribute('data-requesttoken') : null;
    }
    return token;
}
/**
 * Add an observer which is called when the CSRF token changes
 *
 * @param observer The observer
 */
function onRequestTokenUpdate(observer) {
    observers.push(observer);
}
// Listen to server event and keep token in sync
subscribe('csrf-token-update', e => {
    token = e.token;
    observers.forEach(observer => {
        try {
            observer(e.token);
        }
        catch (e) {
            console.error('error updating CSRF token observer', e);
        }
    });
});

/// <reference types="@nextcloud/typings" />
const getAttribute = (el, attribute) => {
    if (el) {
        return el.getAttribute(attribute);
    }
    return null;
};
let currentUser = undefined;
function getCurrentUser() {
    if (currentUser !== undefined) {
        return currentUser;
    }
    const head = document?.getElementsByTagName('head')[0];
    if (!head) {
        return null;
    }
    // No user logged in so cache and return null
    const uid = getAttribute(head, 'data-user');
    if (uid === null) {
        currentUser = null;
        return currentUser;
    }
    currentUser = {
        uid,
        displayName: getAttribute(head, 'data-user-displayname'),
        isAdmin: (typeof OC === 'undefined') ? false : OC.isUserAdmin(),
    };
    return currentUser;
}

export { getCurrentUser, getRequestToken, onRequestTokenUpdate };
//# sourceMappingURL=index.es.mjs.map
